/* eslint-disable no-undef */
import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bannerImage from "./../assets/banner/portada.jpg";
import imgVertical from "./../assets/banner/imgvertical.jpg";
import logvefase from "./../assets/banner/logo-negro.webp";
import { FaAccessibleIcon } from "react-icons/fa";
import Banner from "../components/Banner";
import AccessibilityModal from "./../components/AccessibilityModal";
import BlogPosts from "../components/BlogPosts";
import { Link } from "react-router-dom";

const Home = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <div className="micolor-jm">
      <Header />
     <button className="floating-button" onClick={toggleModal}>
    <img 
        src={require("../assets/clientes/iconoaccesibilidad.jpg")} 
        alt="Menú de accesibilidad"
        onError={(e) => {
            e.target.onerror = null; 
            e.target.src = "ruta-de-reserva.jpg"; // Opcional: imagen alternativa
        }}
    />
</button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />

      <Banner />

      <div className="container">
        <div className="row row-jm">
          {/*     /////////////////servicios//////////////////////////////// */}

          <div className="col-md-6 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">SERVICIOS</h2>
          </div>
          <div className="col-md-12 col-sm-12 mt-5">
            <p className="mitexto text-center">
              Conoce nuestros servicios y empieza a crear espacios pensados para
              todas las personas.
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/nueva5.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          
             <Link to="/productos">
                  <button className="contact-button"> Diagnósticos y Estudio de accesibilidad</button>
                </Link>
          </div>

          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/servicios33.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          
             <Link to="/productos">
                  <button className="contact-button">  Señalización<br></br> accesible</button>
                </Link>
          </div>

          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/nueva6.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          
               <Link to="/productos">
                  <button className="contact-button">  Capacitaciones y <br></br>talleres</button>
                </Link>
          </div>

          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/nueva2.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
            />
           
                 <Link to="/productos">
                  <button className="contact-button"> Implementación: Diseño, obra y supervisión</button>
                </Link>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/nueva1.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          
              <Link to="/productos">
                  <button className="contact-button">   Comunicación <br></br>Accesible</button>
                </Link>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/home/servicios22.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
            />
        
                      <Link to="/productos">
                  <button className="contact-button">Asesoría en Inserción Laboral y ajustes razonables</button>
                </Link>
          </div>

          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title ">PRODUCTOS</h2>
          </div>
          <div
            className="row text-center"
            style={{ paddingLeft: "10%", paddingRight: "10%" }}
          >
            <div className="row" style={{ backgroundColor: "white" }}>
              <div className="col-md-5 col-sm-12 mt-5 ">
                <img
                  src={require("../assets/home/hi.jpg")}
                  alt="Imagen vertical"
                  className="img-vertical"
                  style={{
                    marginTop: "-15%",
                    width: "90%",
                  }}
                />
              </div>
              <div className="col-md-7 col-sm-12  mb-5 text-left">
                <h2 className="mt-4 text-left mb-3" style={{ color: "black" }}>
                  Soluciones accesibles para cada espacio
                </h2>
                <p className="mitexto text-left mt-4">
                  Ofrecemos una amplia variedad de productos para mejorar la
                  accesibilidad en tus espacios. Desde señalización accesible
                  hasta soluciones táctiles, cada elemento está pensado para
                  brindar espacios más seguros, funcionales y amigables. ¿Tienes
                  un proyecto en mente? Escríbenos y te ayudamos a elegir las
                  opciones más adecuadas.
                </p>

                <Link to="/productos">
                  <button className="contact-button">Ver mas productos</button>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">¿QUIENES SOMOS?</h2>
            <p className="mitexto">
              Hábitat Inclusión está conformado por especialistas en temas de
              Accesibilidad y Diseño Universal que buscan crear soluciones en el
              entorno urbano, edificaciones y los servicios, para que todas las
              personas, especialmente aquellas con discapacidad o movilidad
              reducida, puedan disfrutar plenamente de la ciudad y el entorno.
            </p>
          
                <Link to="/nosotros">
                  <button className="contact-button">Conócenos</button>
                </Link>
          </div>
          <div className="col-md-6 col-sm-12 mt-4 center-img">
            <img
              src={require("../assets/banner/Habitat Inclusion-02.jpg")}
              alt="Imagen vertical"
              className="img-vertical-nosotros"
            />
          </div>

          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">COMUNIDAD</h2>
          </div>
          <div
            className="row text-center"
            style={{ paddingLeft: "5%", paddingRight: "5%" }}
          >
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <img
                  src={require("../assets/home/comunidad.jpg")}
                  alt="Imagen vertical"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <h2
                  className="mt-4 text-center mb-2"
                  style={{ color: "black" }}
                >
                  Únete a nuestra comunidad
                </h2>

                <p
                  className="mitexto text-center mt-2"
                  style={{ color: "grey", fontSize: 20 }}
                >
                  Forma parte de una comunidad donde compartimos novedades,
                  recursos, eventos y experiencias sobre accesibilidad, diseño
                  universal e inclusión. Construyamos juntos espacios para todas
                  las personas.
                </p>
                <button
                  className="contact-button mt-1 mb-3"
                  onClick={() =>
                    window.open(
                      "https://docs.google.com/forms/d/1iZjINkMSwPujYet28WNRrMhYf0L6k1nRrHaOqbht-p4/prefill",
                      "_blank"
                    )
                  }
                >
                  Unirme
                </button>
                <br />
              </div>
            </div>
          </div>

          <div className="col-md-12 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title mt-5">
              CLIENTES QUE CONFIAN EN NOSOTROS
            </h2>
          </div>
          <div className="col-md-12 col-sm-12 mt-5"></div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/clientes/logo1h.png")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/clientes/logo2h.png")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/clientes/logo3h.png")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/clientes/logo4h.png")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/clientes/logo6h.png")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-center">
            <img
              src={require("../assets/clientes/logo5h.png")}
              alt="Imagen vertical"
              className="img-vertical"
            />
          </div>

          <div className="col-md-6 col-sm-12 mt-5 mb-2">
            <h2 className="mt-4 sobre-nosotras-title">BLOG</h2>
          </div>

          <div className="col-md-12 col-sm-12"></div>
          
          {/* Componente dinámico para mostrar los últimos 2 posts */}
          <BlogPosts />
          <div className="col-md-12 col-sm-12 mt-5 mb-5"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
